angular.module('jv.common.pagination.directive', [])
.value('jvPaginationTemplateUrl', 'htm/common/pagination-template.html')
.directive('jvPagination', [
    'jvPaginationTemplateUrl',
    function(templateUrl) {
        return {
            scope: {
                currentPage: '=',
                totalCount: '=',
                pageSize: '=',
                onNext: '&',
                onPrevious: '&'
            },
            link: function(scope) {
                scope.hasNext = function() {
                    return (scope.currentPage + 1) * scope.pageSize < scope.totalCount;
                };
                scope.hasPrevious = function() {
                    return (scope.currentPage > 0);
                };
                scope.showingLowerRange = function() {
                    return scope.currentPage * scope.pageSize + 1;
                };
                scope.showingUpperRange = function() {
                    return Math.min(scope.currentPage * scope.pageSize + scope.pageSize, scope.totalCount);
                };
                scope.next = function() {
                    scope.onNext();
                };
                scope.previous = function() {
                    scope.onPrevious();
                };
            },
            templateUrl: templateUrl
        }
    }
]);
